export const COLOR_THEME_COOKIE_NAME = 'color_theme';
export const IS_DARK_MODE_BANNER_CLOSED_LOCAL_STORAGE_KEY = 'dark_mode_banner_closed';
export let ColorTheme;

(function (ColorTheme) {
  ColorTheme["Dark"] = "dark";
  ColorTheme["Light"] = "light";
})(ColorTheme || (ColorTheme = {}));